import {RequestService} from './shared/service/request.service';
import { Component, isDevMode, AfterViewInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import * as $ from 'jquery';
import {Api} from './shared/config/api';
import {SessionService} from './shared/service/session.service';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import { BrowserService } from './shared/service/browser.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {

  constructor(
    translate: TranslateService,
    public router: Router,
    public requestService: RequestService,
    public sessionService: SessionService,
    private browser: BrowserService
  ) {

    // setInterval(() => {
    //   this.requestService._raw().get(Api.Common.session).catch(this.sessionCheck.bind(this)).subscribe();
    // }, 3000);


    $(document).on('keydown', function(event) {
      if (event.which === 8 && !$(event.target).is('input, textarea')) {
        event.preventDefault();
      }
    });


    translate.setDefaultLang('en');
  }

  ngAfterViewInit() {
    if (!isDevMode()) {
      setInterval(() => {
        if (this.browser.isIE()) {
          const element: any = new Image();
          element.__defineGetter__('id', () => {
            alert('Debugger Detected (IE)');
            location.reload();
          });
          console.log(element);
        } else {
          // Chrome 77 빌드 업데이트 이후 대응
          let div: HTMLElement = window.document.getElementsByName('consoleCheck')[0];
          if (!div) {
            div = window.document.createElement('div');
          }
          div.setAttribute('name', 'consoleCheck');
          Object.defineProperty(div, 'id', {get: () => {
            alert('Debugger Detected (not IE)');
            location.reload();
          }});
          console.log(div);
        }
        console.clear();
      }, 100);
    }
  }

  sessionCheck() {
    if (this.sessionService.getSession()) {
      alert('Session has been expired');
      if (this.router.url.includes('/admin__')) {
        this.router.navigate(['/admin__/login']);
      } else {
        this.router.navigate(['/agent/login']);
      }
      return Observable.of();
    }
    return Observable.of();

  }

  public get isRequesting() {
    return this.requestService.requestStatus();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts